import { UserPhoneInfoJSON, UserPhoneInfo } from './user-phone-info.model';

export interface CallingTreeCoordinatorJSON {
	name: string;
	phones: UserPhoneInfoJSON[];
	nuqHousing: boolean;
	address1: string;
	address2: string;
	address3: string;
	compound: string;
	unit: string;
}

export class CallingTreeCoordinator {
	constructor(
		public name: string,
		public phones: UserPhoneInfo[],
		public nuqHousing: boolean,
		public address1: string,
		public address2: string,
		public address3: string,
		public compound: string,
		public unit: string
	) {}

	static fromJSON(json: CallingTreeCoordinatorJSON): CallingTreeCoordinator {
		return Object.assign(
			Object.create(CallingTreeCoordinator.prototype),
			json,
			{
				phones: json.phones
					? json.phones.map((phone) => UserPhoneInfo.fromJSON(phone))
					: [],
			}
		);
	}
}
